/**
 * Add Settings page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Directive, Input, SimpleChanges, Component, ViewEncapsulation, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ItemReorderEventDetail, AlertController, LoadingController, ToastController, ModalController, NavController, Platform, ActionSheetController, NavParams } from '@ionic/angular';
declare var require: any;
var moment = require('moment');

import { PouchService } from '../services/pouch-service';
import { Title } from '@angular/platform-browser';
import { JsonEditorPage } from '../jsoneditor/jsoneditor';
@Component({
  selector: 'page-add-setting',
  templateUrl: 'add-setting.html',
  styleUrls: ['add-setting.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddSettingPage implements OnChanges {
  @Input() isform: boolean = false;
  @Input() ispage: boolean = true;
  objectKeys = Object.keys;
  @Input() setting: any = {
    id: '',
  };
  navParams = {};
  key = {
    name: '',
    type: 'input',
  };
  enableoption = false;
  manage = true;
  loading: any;
  option = '';
  option_description = '';
  core = ['product', 'sale', 'expense', 'appointment', 'event', 'income', 'purchase', 'setting', 'user', 'customer', 'service', 'template', 'task', 'prescription', 'note', 'quotation', 'staff', 'category', 'stockaudit'];
  reserved = ['', 'id', 'rev', 'icon', '_id', '_rev', 'home', 'summary', 'menu', 'child', 'page_type', 'modal', 'display', 'setting', 'keys'];
  item = null; //used for passing item that should be modified via select option
  system_admin = false;

  constructor(public navParams2: NavParams, private titleService: Title, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public router: Router, public toastController: ToastController, public modalCtrl: ModalController, public db: PouchService, public navCtrl: NavController) {
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : this.navParams2.data;
    if (this.navParams != undefined && this.navParams['mode'] != undefined) {
      this.db.get(this.navParams['mode'], 'setting').then((setting) => {
        this.setting = setting;
      });
    } else {
      this.manage = false;
      this.setting = {
        id: '',
        rev: '',
        keys: [],
        icon: 'document',
        display: 'list',
        home: false,
        home_summary: 'count',
        menu: false,
        page_type: 'default',
        modal: true,
        child: false,
        user_access: false,
      };
    }
    this.titleService.setTitle(`Edit ${this.setting?.id} Setting - ${this.db.gsetting.username} - ${this.db.appinfo.title}`);
    if (location.hostname == 'localhost' && this.db.gsetting.username == `${this.db.appinfo.base_product}test`) {
      let mythis = this;
      window.onkeydown = function (e) {
        // toggle system admin
        if ((e.keyIdentifier == 'Control' || e.ctrlKey) && (e.keyIdentifier == 'Shift' || e.shiftKey == true) && (e.key === 'a' || e.key === 'A')) {
          mythis.system_admin = !mythis.system_admin;
          mythis.presentToast(`System Admin Mode ${mythis.system_admin ? 'Activated' : 'Deactivated'}`, mythis.system_admin ? 'toast-success' : 'toast-danger');
        }
      };
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      this[key] = changes[key].currentValue;
    });
  }

  async ngOnInit() {
    if (!(location.hostname == 'localhost' && this.db.gsetting.username == `${this.db.appinfo.base_product}test`)) {
      let data: any = await this.db.fetchLocalSchema('');
      this.core = data.schema.map((obj) => obj.singular);
    }
  }

  typeOf(val) {
    //workaround for typeof not available in ionic template view
    let type: any = typeof val;
    if (type == 'object') {
      if (this.isArray(val)) {
        type = 'array';
      }
    }
    return type;
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  async reset() {
    this.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    await this.loading.present();
    this.db.getJSON('./assets/data/settings.json').subscribe(async (data) => {
      let settings = data.json();
      let oldsetting = settings.find((setting) => setting.id == this.setting.id);
      if (oldsetting != undefined) {
        oldsetting.rev = this.setting.rev;
        this.setting = oldsetting;
      }
      await this.loading.dismiss();
    });
  }

  isArray(arr) {
    return arr.constructor.toString().indexOf('Array') > -1;
  }

  convertToNumber(event): number {
    return +event;
  } //workaround for number input returning string

  async setTooltip(item) {
    let alert = await this.alertCtrl.create({
      header: 'Enter Tool Tip',
      inputs: [
        {
          name: 'tooltip',
          value: this.setting[item].tooltip,
        },
      ],
      buttons: [
        {
          text: this.db.rename('Cancel'),
          handler: (data) => {},
        },
        {
          text: 'Save',
          handler: (data) => {
            this.setting[item].tooltip = data.tooltip;
          },
        },
      ],
    });
    alert.present();
  }

  async setIcon(item) {
    let alert = await this.alertCtrl.create({
      header: 'Enter Font-awesome Icon',
      inputs: [
        {
          name: 'icon',
          value: this.setting[item].icon,
        },
      ],
      buttons: [
        {
          text: this.db.rename('Cancel'),
          handler: (data) => {},
        },
        {
          text: 'Save',
          handler: (data) => {
            this.setting[item].icon = data.icon;
          },
        },
      ],
    });
    alert.present();
  }

  validateId(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === '_') {
      event.preventDefault();
    }
  }

  addKey() {
    if (this.reserved.includes(this.key.name)) {
      this.presentToast('Key Name is reserved or Empty, Please enter another Key', 'toast-danger');
    } else {
      this.setting[this.key.name] = {
        type: this.key.type,
        required: false,
        core: false,
      };
      if (this.key.type == 'image') {
        this.setting[this.key.name].val = 'assets/img/product.png';
      }
      if (this.key.type == 'number') {
        this.setting[this.key.name].options = [];
        this.setting[this.key.name].val = 0;
      }
      if (this.key.type == 'select' || this.key.type == 'spreadsheet') {
        this.setting[this.key.name].options = [];
      }
      if (this.key.type == 'object') {
        this.setting[this.key.name].val = '';
        this.setting[this.key.name].showdoc = false;
      }
      if (this.key.type == 'array') {
        this.setting[this.key.name].showdoc = false; //here showdoc option makes the array to be embeded in the entity (entity.key = [array of items])
      }
      if (this.key.name != 'id' && this.key.name != 'rev') {
        this.setting.keys.push(this.key.name);
      }
    }
    //reset key
    this.key = {
      name: '',
      type: 'input',
    };
  }

  enableOption(item) {
    this.enableoption = true;
    this.item = item;
  }

  addOption() {
    this.setting[this.item].options.push(this.option);
    this.setting[this.item].option_description = this.option_description;
    this.enableoption = false;
    this.option = '';
  }

  reorderItem(event: CustomEvent<ItemReorderEventDetail>) {
    const reordered = event.detail.complete(this.setting.keys);
    this.setting.keys = reordered;
  }

  removeOption() {
    this.setting[this.item].options = this.setting[this.item].options.filter((e) => e !== this.option);
    this.enableoption = false;
    this.option = '';
  }

  deleteKey(key) {
    if (key != 'id' && key != 'rev' && key != 'keys') {
      delete this.setting[key];
    }
    this.setting.keys = this.setting.keys.filter((e) => e !== key);
  }

  submit() {
    if (this.isform) {
      this.db.update(this.setting, 'form').then((res) => {
        this.presentToast('Form saved Successfully', 'toast-success');
      });
    } else {
      if (this.setting.id != '' && this.setting.keys.length > 0) {
        if (this.navParams != undefined && this.navParams['mode'] != undefined) {
          this.db.update(this.setting, 'setting').then((setting) => {
            this.modalCtrl.dismiss(setting);
          });
        } else {
          this.db.update(this.setting, 'setting').then((setting) => {
            if (setting.error) {
              this.presentToast('ID already taken. Please enter a valid one!', 'toast-danger');
            } else {
              this.db.get('schema', undefined).then((doc) => {
                doc.schema.push({
                  singular: this.setting.id,
                  plural: this.setting.id + 's',
                });
                this.db.update(doc, undefined).then((doc) => {
                  this.db.initDB(this.db.credentials).then((res) => {
                    this.modalCtrl.dismiss(setting);
                  });
                });
              });
            }
          });
        }
      } else {
        this.presentToast('You must enter an ID and at least 1 key', 'toast-danger');
      }
    }
  }

  async viewJSON() {
    let modal = await this.modalCtrl.create({
      component: JsonEditorPage,
      componentProps: { entity: this.setting, options: { mode: 'code' }, edit: true },
    });
    modal.onDidDismiss().then((res) => {
      if (res.data != undefined) {
        this.setting = {
          ...res.data,
          rev: this.setting.rev,
        };
      }
    });
    await modal.present();
  }

  async delete() {
    const alert = await this.alertCtrl.create({
      header: 'Delete Entity?',
      message: '<p>Please Ensure you know what you are doing before you proceed, this will remove this entity from this app. click on help to learn more</p>',
      buttons: [
        {
          text: this.db.rename('Cancel'),
          role: 'cancel',
        },
        {
          text: 'Proceed',
          handler: () => {
            this.db.removeAll(this.setting.id).then((res) => {
              this.db.remove(this.setting, 'setting').then((res2) => {
                this.db.get('schema', undefined).then((doc) => {
                  doc.schema = doc.schema.filter((obj) => obj.singular != this.setting.id);
                  this.db.update(doc, undefined).then((doc) => {
                    this.db.initDB(this.db.credentials).then((res) => {
                      this.modalCtrl.dismiss(this.setting);
                    });
                  });
                });
              });
            });
          },
        },
      ],
    });
    alert.present();
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
